import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { copyExerciseSession, moveExerciseSession } from '../../../api/diary-service';

const useSessionCopyOrMove = (actionType) => {
    const [isProcessingAndSyncing, setIsProcessingAndSyncing] = useState(false);
    const queryClient = useQueryClient();

    const isMove = actionType === 'move';
    const mutationFn = isMove ? moveExerciseSession : copyExerciseSession;

    const mutation = useMutation({
        mutationFn,
        onError: (error) => {
            console.error(`Failed to ${isMove ? 'move' : 'copy'} exercise session:`, error);
        }
    });

    const triggerSessionAction = async ({ from_date, to_date }) => {
        setIsProcessingAndSyncing(true);

        try {
            await mutation.mutateAsync({ from_date, to_date });

            await Promise.all([
                queryClient.refetchQueries({ queryKey: ['diary', from_date] }),
                queryClient.refetchQueries({ queryKey: ['diary', to_date] }),
                queryClient.refetchQueries({ queryKey: ['energy', 'period'], exact: false })
            ]);

            await queryClient.invalidateQueries({
                queryKey: ['exerciseSessionDates'],
                exact: false
            });

            return true;
        } catch {
            return false;
        } finally {
            setIsProcessingAndSyncing(false);
        }
    };

    return {
        triggerAction: triggerSessionAction,
        isProcessing: isProcessingAndSyncing,
        isError: mutation.isError,
        error: mutation.error,
        reset: mutation.reset
    };
};

export default useSessionCopyOrMove;
